export default __webpack_public_path__ + "static/media/akam.8719da34.svg";